<template>
	<Transition>
		<div class="pop-bg" v-show="props.isShow">
			<div class="pop-box">
				<img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="emit('closeToast')">
				<h2 class="pop-title">{{ $t('查看视频资源') }}</h2>
				<div class="inside">
					<h2>{{ $t('请选择日期') }}</h2>
					<h3>{{ $t('只可查看近七天视频资源') }}</h3>
					<div class="weekRow">
<!--						<div class="active">&lt;!&ndash;选中样式class active&ndash;&gt;-->
<!--							<span class="week">今天</span>-->
<!--							<span class="date">12.12</span>-->
<!--						</div>-->
						<div :class="{ active: choiceDateIndex == index }" @click="choiceDate(item,index)" v-for="(item, index) in state.DateList">
							<span class="week">{{ item.week }}</span>
							<span class="date">{{ item.date }}</span>
						</div>
<!--						<div>-->
<!--							<span class="week">星期二</span>-->
<!--							<span class="date">12.13</span>-->
<!--						</div>-->
					</div>
					<h2>{{ $t('时间段') }}</h2>
					<div class="timeRow">
<!--						<div class="none">&lt;!&ndash;暂无样式class none&ndash;&gt;-->
<!--							<span class="time">07:00-07:30</span>-->
<!--							<span class="surplus">剩余23</span>-->
<!--						</div>-->
						<div :class="{ none: item.outmoded }" v-for="(item, index) in state.timeList">
							<span class="time">{{ item.time }}</span>
							<span class="surplus">{{ $t('剩余') }}{{ item.usableCount }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Transition>
</template>
<script setup>
import {onMounted, reactive, ref} from "vue";
import {countPexipOccupy} from "@/api/yuzhen/meeting";

	const props = defineProps(["isShow"]);
	const emit = defineEmits()
	const passShow = ref(true)
  const choiceDateIndex = ref(0); // 选中
  const state = reactive({
    DateList: [
      // {
      //   date: 4.3,
      //   week: "星期一",
      //   value: new Date()
      // },
    ],
    timeList:[
    ]
  })
  function choiceDate(item,index){
    choiceDateIndex.value = index
    getPexipOccupy(item.value.getTime())
  }

  function getPexipOccupy(time){

    var query = {
      date: time,
    }
    countPexipOccupy(query).then(res => {
      console.log(res);
      state.timeList = []
      state.timeList = res.data;
    })
  }

const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']; // 星期
  function getDate(){
    for(let i = 0; i < 7; i++){
      let date = new Date();
      date.setDate(date.getDate() + i);
      state.DateList.push({
        date: (date.getMonth() + 1 ) + "." + date.getDate(),
        week: week[date.getDay()],
        value: date
      })
    }
  }

  onMounted(() => {
    getPexipOccupy(new Date().getTime());
    getDate()
  })
</script>
<style src="./videoResource.css" scoped></style>
